/* eslint-disable implicit-arrow-linebreak */
import React, { useEffect, useState } from 'react';

import ReactModal from 'react-modal';
import closeSvg from 'src/assets/close.svg';

import { useTranslation } from 'react-i18next';
import { CommonInput, AlertAdapter } from 'pg-ui-library';

import { useTypedSelector } from 'src/hooks/useTypedSelector';
import {
  ButtonContainer,
  CloseIcon,
  Content,
  FormButton,
  FormTitle,
  Header,
  FormRow,
  ModalContent,
  ContainerValidation,
} from './styles';

export const SignSubmitModal: React.FC<{
  isOpen: boolean;
  onRequestClose: () => void;
  onCloseSuccess: () => void;
}> = ({ isOpen, onRequestClose, onCloseSuccess }) => {
  const [signature, setSignature] = useState('');
  const [modalIsOpen, setIsOpen] = useState<boolean>(isOpen);
  const { personalInfo } = useTypedSelector(state => state.personalInfo.data);
  const { t } = useTranslation();

  const fullName = `${personalInfo?.firstName} ${personalInfo?.lastName}`;

  const signatureMatch = signature === fullName;

  useEffect(() => {
    setIsOpen(isOpen);
  }, [isOpen]);

  const handleModal = () => {
    setIsOpen(prevIsOpen => !prevIsOpen);
    onRequestClose();
  };

  const isValidFormat = (input: string) => {
    const words = input.split(/\s+/);
    const regex = /^[A-Zs][a-z\s]*$/;
    if (input) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < words.length; i++) {
        if (!regex.test(words[i]) && words[i] !== '') {
          return false;
        }
      }
      return true;
    }
    return true;
  };

  const onSign = () => {
    if (!signatureMatch) return;
    onCloseSuccess();
    handleModal();
  };

  return (
    <ReactModal
      isOpen={modalIsOpen}
      ariaHideApp={false}
      onRequestClose={handleModal}
      style={{
        overlay: {
          margin: 'auto',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        },
        content: {
          borderRadius: '30px',
          margin: 'auto',
          width: '1188px',
          height: '336px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          padding: '40px',
          overflowY: 'hidden',
        },
      }}
    >
      <Header>
        <FormTitle>{t('benefits.signModal.title')}</FormTitle>
        <CloseIcon src={closeSvg} onClick={() => handleModal()} />
      </Header>

      <Content>
        <ModalContent>
          <FormRow>
            <CommonInput
              style={{ width: '100%' }}
              id="name"
              name="name"
              label="Name"
              value={fullName}
              onChange={() => {}}
              onPaste={(e: any) => {
                e.preventDefault();
                return false;
              }}
              onCopy={(e: any) => {
                e.preventDefault();
                AlertAdapter('Copy and Paste action not available for this field', 'warning');
                return false;
              }}
              disabled
            />
            <ContainerValidation>
              <CommonInput
                style={{ width: '100%' }}
                id="signature"
                name="signature"
                label="Signature"
                onPaste={(e: any) => {
                  e.preventDefault();
                  AlertAdapter('Copy and Paste action not available for this field', 'warning');
                  return false;
                }}
                onCopy={(e: any) => {
                  e.preventDefault();
                  return false;
                }}
                autoComplete="off"
                value={signature}
                onChange={ev => {
                  setSignature(ev.currentTarget.value);
                }}
              />
              <div style={{ alignSelf: 'right' }}>
                <p style={{ color: 'red', fontSize: '10pt', minHeight: '20px' }}>
                  {signatureMatch ? '' : 'Signature does not match the name'}
                </p>
                <p style={{ color: 'red', fontSize: '10pt', minHeight: '20px' }}>
                  {isValidFormat(signature) ? '' : 'Please verify uppercase and lowercase'}
                </p>
              </div>
            </ContainerValidation>
          </FormRow>
        </ModalContent>
        <ButtonContainer>
          <FormButton disabled={!signatureMatch} onClick={() => onSign()}>
            {t('global.form.submit')}
          </FormButton>
        </ButtonContainer>
      </Content>
    </ReactModal>
  );
};
